<template>
  <div class="statistic-data">
    <div class="bg-white p-4 mt-4 rounded-lg">
      <div class="d-lg-flex align-items-center justify-content-md-between">
        <h4 class="text-left mb-4">{{ title }}</h4>
        <!-- <button class="btn btn-sm btn-light" @click="handleCustom"><i class="fas fa-ellipsis-v"></i></button> -->

      </div>
      <div class="row align-items-lg-end justify-content-start flex-nowrap gap-3">
        <div :class="data.length >= 2 ? 'col' : 'col-lg-3'" v-for="item, index in data" :key="index">
          <div class="d-lg-flex d-flex gap-lg-3 gap-1 align-items-lg-end align-items-end justify-content-lg-start justify-content-lg-start mb-lg-0 mb-3">
            <div v-if="item.icon" class="statistic-icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="text-left">
              <h6 class="statistic-label text-secondary">{{ item.label }}</h6>
              <h5 class="statistic-key font-weight-medium mb-0">{{ item.key }}</h5>
            </div>
            <div>
              <h3 :class="`statistic-value text-${item.color} mb-0`"><strong>{{ item.value }}</strong></h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StatisticData',
  components: {
    
  },
  props :{
    title: String,
    data: Array,
  },
  setup(props, {emit}){
    console.log(props)

    const handleCustom = (value) => {
      emit("show", value)
    }
    return {
      handleCustom
    }

  }
}
</script>

<style>

</style>